<template>
  <div class="layout">
    <Header class="layout-header" />

    <div class="layout-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'

export default {
  components: { Header }
}
</script>

<style scoped>
.layout {
  min-height: 100vh;
  background: #f5f5f5;
}

.layout-header {
  width: 100%;
  height: 60px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.layout-content {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}
</style>
